module.exports = __webpack_public_path__ + "img/pdf.88d0000e.png";